export default __webpack_public_path__ + "static/media/Allan_Brito_Capa.85ff14db.jpeg";